module.exports = __webpack_public_path__ + "img/1513928316.0207ee3c.jpg";